import { Component, inject, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AccordionComponent } from "../../../shared/components/accordion/accordion.component";
import { AuthorizeDirective } from '../../../shared/authorization/authorize.directive.';
import { MEMBER_VIEW_PAGE_IDS, PAGE_CONSTANTS, TABS } from '../../../shared/constants/page.constants';
import { SectionsService } from '../../../services/sections.service';
import { Router } from '@angular/router';
import { STATIC_DATA, STATIC_JSON_DATA_PATH } from '../../../shared/constants/static-data.constants';
import { ListTableComponent } from "../../../shared/components/list-table/list-table.component";
import { TableRowActionsModel } from '../../../shared/interfaces/list.interface';
import { TableRowActions } from '../../../shared/interfaces/actions';
import { NgZorroModule } from '../../../shared/modules/ng-zorro/ng-zorro.module';
import { BaseComponent } from '../../../shared/utils/base.component';
import { PopupDialogComponent } from "../../../shared/components/popup-dialog/popup-dialog.component";
import { DialogConfig, DialogService } from '../../../shared/services/dialog.service';
import { noop } from 'rxjs';
import { LeadDetailsService } from '../../../services/lead-details.service';
import { AuthorizationDetailsComponent } from '../../payroll/authorizations/authorization-details/authorization-details.component';
import { UserService } from '../../../services/user.service';
import { ListService } from '../../../shared/services/list.service';
import { AuthorizationService } from '../../../services/authorization.service';
import { ButtonComponent } from "../../../shared/components/button/button.component";
import { AuthAllocationComponent } from './auth-allocation/auth-allocation.component';
import { AuthorizationUtility } from '../../../shared/authorization/auth.utility';

@Component({
  selector: 'ppl-authorization',
  standalone: true,
  imports: [AccordionComponent, AuthorizeDirective, ListTableComponent, NgZorroModule, AuthorizationDetailsComponent, ButtonComponent,
    AuthAllocationComponent
  ],
  templateUrl: './authorization.component.html',
  styleUrl: './authorization.component.css'
})
export class AuthorizationComponent extends BaseComponent implements OnInit {
  @Input() readOnly = false;
  @ViewChild('dialogContent') dialogContent!: TemplateRef<any>;
  entry: string | null =  '';
  title = '';
  tabId = TABS.Authorization;
  programName!: string;
  columnsToBeHidden: any;
  sharedDataKey: any;
  actionsToBeHidden: any;
  lazyLoad = true;
  isPageRestrictionLoaded = false;
  actionButtonsApproved: TableRowActionsModel = new TableRowActions({view: true});
  weeklyLimitButtons: TableRowActions = new TableRowActions({edit: true, history: true})
  actionButtonsErrored: TableRowActionsModel = new TableRowActions();
  approvedData: any;
  approvedCurrentData: any;
  approvedPastData: any;
  approvedUpcomingData: any;
  erroredOutData: any;
  selectedLead = 0;
  approvedCols: any;
  erroredCols: any;
  weeklyLimitCols: any;
  weeklyLimitData: any;
  @ViewChild('authDialog') authDialog!: TemplateRef<any>;
  @ViewChild('historyDialog') historyDialog!: TemplateRef<any>;
  private dialogSvc = inject(DialogService);
  id: any;
  pageSource: string | null = '';
  pageId = MEMBER_VIEW_PAGE_IDS[this.userService.getFirstSegment()!];
  historyData: any;
  mode = 'read';
  authData: any;
  viewActions = false;
  historyCols = [
    {
      field: "tasAuthorizationXProviderId",
      header: "Id",
      jsonpath: "tasAuthorizationXProviderId"
    },
    {
      field: "svcDesc",
      header: "Service Code",
      jsonpath: "svcDesc"
    },
    {
      field: "providerName",
      header: "PA Name",
      jsonpath: "providerName"
    },
    {
      field: "startDate",
      header: "Start Date",
      jsonpath: "startDate"
    },
    {
      field: "endDate",
      header: "End Date",
      jsonpath: "endDate"
    },
    {
      field: "hours",
      header: "Weekly Limit Hours",
      jsonpath: "hours"
    },
    {
      field: "mco",
      header: "MCO",
      jsonpath: "mco"
    },
    {
      field: "operation",
      header: "Operation",
      jsonpath: "operation"
    },
    {
      field: "createdByName",
      header: "Created By",
      jsonpath: "createdByName"
    },
    {
      field: "createdDate",
      header: "Created Date",
      jsonpath: "createdDate"
    },
    {
      field: "modifiedByName",
      header: "Modified By",
      jsonpath: "modifiedByName"
    },
    {
      field: "modifiedDate",
      header: "Modified Date",
      jsonpath: "modifiedDate"
    }
  ];

  constructor(
    private router: Router,
    private sectionsService: SectionsService,
    private leadDetailsService : LeadDetailsService,
    private userService: UserService,
    private listService: ListService,
    private authorizationService: AuthorizationService,
    private authUtility: AuthorizationUtility
  ) {
    super()
  }

  ngOnInit(): void {
    this.id = this.userService.getSelectedLead();
    if(this.entry === 'participant'){
      this.title = 'Authorization Summary'
    }else{
      this.title = 'Paystub history'
    }

    this.pageSource = this.userService.getLeadEntry() ?? '';
    this.entry = this.userService.getLeadEntry() ?? '';
    const program = this.userService.getSelectedProgram();
    this.programName = program?.program_code ?? '';
    this.viewActions = this.authUtility.isSectionEditable(this.pageId, this.tabId, 'Auth_Actions');
    this.getSectionData();
    this.getGridHeaders();
    this.selectedLead = JSON.parse(this.userService.getSelectedLead()!);
    this.getParticipantAuthorizations(this.programName, this.selectedLead );
    this.getWeeklyLimitData();
  }

  async getSectionData() {
    try {
      if (this.entry) {
        this.secData = await this.sectionsService.getJsonConfigurationData(
          STATIC_JSON_DATA_PATH.AUTHORIZATIONS_SECTION_DATA,
          'authorizations'
        );
      }
    } catch (e) {
      console.log('error fetching section data: ', e);
    }
  }

  async getGridHeaders() {
    try {
        if(this.entry) {
        const tempCols = await this.sectionsService.getJsonConfigurationData(STATIC_JSON_DATA_PATH.AUTHORIZATIONS_PARTICIPANT_DETAILS_LIST_HEADERS, this.entry);
        this.approvedCols = tempCols.approvedAuthorizations.columns;
        this.erroredCols = tempCols.erroredAuthorizations.columns;
        this.weeklyLimitCols = tempCols.weeklyLimit.columns;
        }
    } catch (e) {
      console.log("header fetch error: ", e);
    }
  }

  onAddAuthorizations() {
    console.log('process code add button clicked');
    this.router.navigate(['/home/addAuthorizations']);
  }

  cancel(event: any){
    this.mode = 'read';
  }

  savedWeeklyLimit(event: any){
    this.getWeeklyLimitData();
  }

  action(event: any) {
    console.log('acto', event);
    if (event && event.action === 'view') {
      this.openAuthDialog(event.data);
    }
    if (event && event.action === 'history') {
      this.openHistoryDialog(event.data);
    }
    if (event && event.action === 'edit') {
      this.mode = 'edit';
      this.authData = event.data;
    }
    if (event && event.action === 'delete') {
     this.authorizationService.deleteWeeklyLimit(this.programName, event.data.tasAuthorizationXProviderId).subscribe((data:any)=>{
      this.getWeeklyLimitData();
     })
    }
  }

  openHistoryDialog(data: any){
    const payload = {
      "participantId": data.participantId,
      "providerId": data.providerId,
      "servicecodeDetailId": data.servicecodeDetailId,
      "sourceOrgId": data.orgId
  }
    this.authorizationService.getWeeklyLimitHistory(this.programName, payload).subscribe((data)=>{
      this.historyData = data.responsedata;
      const dialogConfig: DialogConfig = {
        title: 'Weekly Limit History',
        isOkText: 'Ok',
        size: 'x-large',
        position: 'top',
        showClose: true,
        showButtons: false,
        styleClass: 'split-auth-data'
      };
  
      this.dialogSvc.openDialog(
        this.historyDialog,
        dialogConfig,
        () => this.handleHistoryCancel(),
        () => this.handleHistoryCancel()
      );
    })

  }

  handleHistoryCancel(){}

  addWeeklyLimit(){
    this.mode = 'add';
  }

  getWeeklyLimitData(): void {
    const payload = {
      "pageName": "weekly-limit-cons",
      "programCode": "NY",
      "condition": "and",
      "recordsPerPage": 20,
      "startingPageNumber": 1,
      "searchParam": [
        {
          jsonPath: "participantId",
          value: this.selectedLead.toString(),
          operator: "Equal"
        }
      ],
      "orderByColumn": ["participantId"],
      "orderBy": [
        "desc"
      ]
    };
  
    this.listService
      .getListData(payload)
      .subscribe((data: any) => {
        if (data.status === 200) {
          const today = new Date();
          this.weeklyLimitData = data.responsedata.map((item: any) => ({
            ...item,
            isFuture: new Date(item.startDate) > today,
            hoursFormatted: item.servicecodeDetailId ? item.hoursFormatted : null,
            actions: {
              delete: new Date(item.startDate) > today && this.viewActions,
              edit: this.viewActions,
              history: item.servicecodeDetailId
            }
          }));
        }
      });
  }

  openAuthDialog(data: any) {
    this.sectionsService.setFlow('authorizations');
    this.userService.setLeadEntry('authorizations');
    this.userService.setSelectedLead(data.authorizationId); 
    const dialogConfig: DialogConfig = {
      title: `Auth Details for ${data.clientAuth}`,
      isOkText: 'Deny',
      size: 'xx-large',
      position: 'top',
      showClose: true,
      showButtons: false,
    };

    this.dialogSvc.openDialog(
      this.authDialog,
      dialogConfig,
      () => this.handleCancel(),
      () => this.handleCancel()
    );
  }

  handleCancel(){
    this.sectionsService.setFlow('participantEnrollment');
    this.userService.setLeadEntry('participantEnrollment');
    this.userService.setSelectedLead(this.id); 
  }

  getParticipantAuthorizations(programCode: string, id: number) {
    const payload = {
      "pageName": "consumer-auth",
      "programCode":programCode,
      "condition" : "and",
      "recordsPerPage": 20,
      "startingPageNumber" : "1",
      "orderByColumn":["participantId"],
      "orderBy":["desc"],
      "searchParam" :[{
              "jsonPath":"participantId",
              "value" : id,
              "operator" : "equal"
         }]
  }
    this.leadDetailsService.getParticipantAuthorizations(payload).subscribe((data: any)=>{
      const authData = data.responsedata.map((item: any) => ({
        ...item,
        isDeleted: item.isDeleted === 'Y' ? 'Yes' : item.isDeleted === 'N' ? 'No' : item.isDeleted
      }));
      this.approvedData = authData.filter((item: any) => item.statusLkp?.toLowerCase() === 'approved')
      .map((item: any) => ({
        ...item,
        arialabel: 'Approved authorization ' + item.clientAuth
      }))
      .sort((a: any, b: any) =>
        !a.endDate ? -1 :
        !b.endDate ? 1 :
        new Date(b.endDate).getTime() - new Date(a.endDate).getTime()
      );

    this.approvedUpcomingData = this.approvedData.filter(
      (item: any) => item.authStatus?.toLowerCase() === 'upcoming'
    );
  
    this.approvedCurrentData = this.approvedData.filter(
      (item: any) => item.authStatus?.toLowerCase() === 'current'
    );
  
    this.approvedPastData = this.approvedData.filter(
      (item: any) => item.authStatus?.toLowerCase() === 'inactive/past'
    );

    this.erroredOutData = authData.filter((item: any) => item.statusLkp?.toLowerCase() !== 'approved')
      .map((item: any) => ({
        ...item,
        arialabel: 'Errored out authorization ' + item.clientAuth
      }))
      .sort((a: any, b: any) =>
        !a.endDate ? -1 :
        !b.endDate ? 1 :
        new Date(b.endDate).getTime() - new Date(a.endDate).getTime()
      );
    })
  }
}
